import {$fetch, $post, $put} from '@/services/axios';

export function fetch(params) {
  return $fetch(`customer/segments`, params);
}

export const CUSTOMER_SEGMENT_CSV_URL = `customer/segments/csv`;

export function validate(model) {
  return $post(`customer/segment/validate`, model);
}

export function add(model) {
  return $put(`customer/segment`, model);
}

export function update(model) {
  return $post(`customer/segment/${model.id}`, model);
}
